import React, {useCallback} from "react";
import AppModal from "../../core/components/app-modal";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import {animated} from "@react-spring/web";
import {useModalAnimation} from "../../core/animations";
import useModalWithData from "@common/hooks/use-modal-with-data";
import AppButton from "@common/components/app-button";

export interface AiErrorResponseModalData {
    message?: string;
    title?: string;
}

const AiErrorResponseModal: React.FC = () => {
    const {data, hideModal, isOpenModal} =
        useModalWithData<AiErrorResponseModalData>(ModalIds.ARTICLE_AI_ERROR_RESPONSE);

    const modalOpen = isOpenModal();
    const {springProps, closeModal} = useModalAnimation(!!modalOpen, "medium");

    const handleAccept = useCallback(() => {
        closeModal(() => hideModal());
    }, [data, hideModal]);

    // jak nie ma nic do pokazania, nie renderuj
    if (!data?.message) return null;

    return (
        <AppModal
            id={ModalIds.ARTICLE_AI_ERROR_RESPONSE}
            key={ModalIds.ARTICLE_AI_ERROR_RESPONSE}
            zIndex={60}
            forceFixed={true}
            classModal="flex justify-center"
        >
            <animated.div
                style={springProps}
                className="w-full h-full flex flex-col bg-surface-level-1 rounded-2xl max-h-[720px] md:min-w-[560px]"
            >
                <div className="flex items-center pl-8 pr-4 py-3 border-b border-outline-mild h-[72px] max-h-[72px]">
                    <h3 className="text-lg font-semibold leading-snug text-on-surface">
                        {data.title}
                    </h3>
                </div>

                <div className="px-8 pt-6 pb-6 overflow-y-auto">
                    <pre
                        className="whitespace-pre-wrap break-words text-sm text-on-surface/80 bg-on-surface/5 rounded-xl p-4">
                        {data.message}
                    </pre>
                </div>

                <div
                    className="flex items-center justify-end gap-2 h-[72px] min-h-[72px] rounded-b-2xl border-t border-outline-mild px-8">
                    <AppButton
                        className="cursor-pointer hover:bg-primary/80 bg-primary max-h-[40px] h-[40px] !px-6 !pt-2 text-on-primary font-semibold text-base !rounded-full"
                        onClick={handleAccept}
                        label="Ok, rozumiem"
                    />
                </div>
            </animated.div>
        </AppModal>
    );
};

export default AiErrorResponseModal;
